import { ColumnData } from "@/entities/dataTables/types";
import {
  APIObject,
  EmptyFilters,
  Filters,
  SortQuery
} from "@/services/api/types";

export const ALL_DEALS_VIEW = "allDeals";
export const OPEN_DEALS_VIEW = "openDeals";
export const ALL_SERVICES_VIEW = "allServices";
export const ACTIVE_SERVICES_VIEW = "activeServices";
export const RENEWAL_RISK_VIEW = "renewalRisk";

export enum ViewType {
  DEALS_KANBAN = 1,
  DEALS_TABLE = 2,
  LEADS_TABLE = 3,
  COMPANIES_TABLE = 4,
  PEOPLE_TABLE = 5,
  CONTRACTS_TABLE = 6,
  SERVICES_TABLE = 7,
  PARTNERS_TABLE = 8,
  PARTNER_CONTACTS_TABLE = 9
}

interface ViewsDataResponse {
  views: ViewData[];
}

interface ViewsConfigResponse {
  config: {
    ordered: Record<string, ViewConfiguration>;
  };
}

interface ViewData extends APIObject {
  name: string;
  type: ViewType;
  createdBy?: string;
  isSystem: boolean;
  config: {
    filters: Filters;
    sort?: SortQuery;
    groupBy?: string[];
    searchTerm?: string;
    columns?: ColumnData[];
  };
}

interface ViewConfiguration {
  isOpen?: boolean;
}

interface ViewDataConfiguration extends ViewData, ViewConfiguration {
  order: number;
}

export const EmptyView = (type: ViewType): ViewDataConfiguration => ({
  order: 0,
  name: "",
  type: type,
  isSystem: false,
  config: {
    filters: EmptyFilters,
    sort: { field: "" },
    groupBy: [],
    searchTerm: "",
    columns: []
  },
  id: ""
});

export type {
  ViewsDataResponse,
  ViewsConfigResponse,
  ViewData,
  ViewDataConfiguration
};
